import type { ViewAsInfo } from '@beaded/models'

import { useAuthContext } from './useUserContext'

/**
 * The active read-only view-as session, or null. Read from the session user
 * (`GET /user/me` sets `viewAs`); never inferred from anything else.
 */
export const useViewAs = (): ViewAsInfo | null => {
  const { currentUser } = useAuthContext()
  return currentUser?.viewAs?.active ? currentUser.viewAs : null
}
